import { Component } from 'react'
import { ContactPoints, Communications, Names, Addresses } from '../helpers'
import { FaUserDoctor } from 'react-icons/fa6'
import { FaFemale, FaMale, FaLanguage, FaRegAddressCard } from 'react-icons/fa'
import { BsFillTelephoneFill } from 'react-icons/bs'
import moment from 'moment'
import './resource.css'

class Practitioner extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isJson: false,
            css: false
        }
    }

    handleJson() {
        this.setState({ css: !this.state.css })
        setTimeout(() => this.setState({ isJson: !this.state.isJson }), 300)
    }

    handleSelect(id) {
        if (this.props.onSelect) this.props.onSelect(id)
    }

    render() {
        return <div className={`Flip-Container`} onClick={() => this.handleJson()}><div className={`Res-Container Res-Allergy${this.state.css ? ' Flip' : ''}`}>
            {this.state.isJson ? <div className='Res-Json'><pre>{JSON.stringify(this.props.resource, undefined, 2)}</pre></div> :
                <div>
                    <div className='Res-row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>Status</div>
                            <div className='Res-Title'>{this.props.resource.active ? 'Active' : 'Inactive'}</div>
                        </div>
                        <div className='Res-Icon-Big'><FaUserDoctor /></div>
                        <div>
                            <div className={`Res-Icon`}>{this.props.resource.gender === 'female' ? <FaFemale /> : <FaMale />}</div>
                            <div className='Res-Icon-Label'>{this.props.resource.gender === 'female' ? 'Female' : "Male"}</div>
                        </div>
                    </div>
                    <div className="Res-Row">
                        <div className="Res-Title">{this.props.resource.name ? Names(this.props.resource.name) : 'Practitioner'}</div>
                    </div>
                    <div className='Res-Row Res-Flex-Spread'>
                        <div>
                            {this.props.resource.telecom && <div className='Res-Row'>
                                <span className={`Res-Icon`}><BsFillTelephoneFill /></span>
                                <div className='Res-Detail'>{ContactPoints(this.props.resource.telecom)}</div>
                            </div>}
                        </div>
                        {this.props.resource.birthDate && <div>
                            <div className='Res-Title'>DOB</div>
                            <div className='Res-Detail'>{moment(this.props.resource.birthDate).format('ll')}</div>
                        </div>}
                    </div>
                    {this.props.resource.communication && <div className='Res-Row'>
                        <span className={`Res-Icon`}><FaLanguage /></span>
                        <div className='Res-Detail'>{Communications(this.props.resource.communication)}</div>
                    </div>}
                    {this.props.resource.address && <div className='Res-Row Res-Flex'>
                        <div className='Res-Icon'><FaRegAddressCard /></div>
                        <div className='Res-Detail'>{Addresses(this.props.resource.address)}</div>
                    </div>}
                </div>
            }
        </div></div>
    }
}

export default Practitioner